import { useNotify, useTranslate } from 'react-admin';

export const useImportErrorHandler = () => {
    const notify = useNotify();
    const translate = useTranslate();

    const getErrorMessage = errorObj => {
        const contextParams = {};
        if (Array.isArray(errorObj.context)) {
            errorObj.context.forEach(item => {
                if (item.key && item.value !== undefined) {
                    contextParams[item.key] = item.value;
                }
            });
        }
        return translate(errorObj.message, contextParams);
    };

    return error => {
        let message = '';
        if (error.message) {
            message = error.message;
        }
        if (error.body?.errors) {
            const violations = error.body.errors.map(err => {
                const field = err.field;
                const translatedMessage = getErrorMessage(err);
                return `• [${field}] ${translatedMessage}`;
            });
            message = `${message}\n${violations.join('\n')}`;
        }
        if (error.status === 504) {
            notify(translate('common.errors.importFailed'), { type: 'error' });
        } else {
            notify(message, { type: 'error', autoHideDuration: null, multiLine: true });
        }
    };
};
